export default function () {
    return {
        restrict: 'E',
        scope: {
            on: '=?'
        },
        link(scope) {
            if (scope.on === undefined) {
                scope.on = true;
            }
        },
        template: `
            <div ng-class="{ spinner: on }"></div>
        `
    };
}



// WEBPACK FOOTER //
// ./Client/app/common/directives/spinner.js